import { ICON_TYPES } from '../constants';

export const NoPlotImage = (): JSX.Element => {
  return (
    <svg
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M48.6666 18.0001V14.0001H46.6666V6.17212L40.6666 0.172119L34.6666 6.17212V14.0001H30.6666V6.17212L24.6666 0.172119L18.6666 6.17212V14.0001H14.6666V6.17212L8.66663 0.172119L2.66663 6.17212V14.0001H0.666626V18.0001H2.66663V32.0001H0.666626V36.0001H2.66663V48.0001H14.6666V36.0001H18.6666V48.0001H30.6666V36.0001H34.6666V48.0001H46.6666V36.0001H48.6666V32.0001H46.6666V18.0001H48.6666ZM38.6666 7.82812L40.6666 5.82812L42.6666 7.82812V14.0001H38.6666V7.82812ZM22.6666 7.82812L24.6666 5.82812L26.6666 7.82812V14.0001H22.6666V7.82812ZM26.6666 18.0001V32.0001H22.6666V18.0001H26.6666ZM6.66663 7.82812L8.66663 5.82812L10.6666 7.82812V14.0001H6.66663V7.82812ZM6.66663 18.0001H10.6666V32.0001H6.66663V18.0001ZM10.6666 44.0001H6.66663V36.0001H10.6666V44.0001ZM14.6666 32.0001V18.0001H18.6666V32.0001H14.6666ZM26.6666 44.0001H22.6666V36.0001H26.6666V44.0001ZM30.6666 32.0001V18.0001H34.6666V32.0001H30.6666ZM42.6666 44.0001H38.6666V36.0001H42.6666V44.0001ZM42.6666 32.0001H38.6666V18.0001H42.6666V32.0001Z"
          fill="#B4D9F3"
        />
      </g>
    </svg>
  );
};

NoPlotImage.iconType = ICON_TYPES.NO_PLOT_IMAGE;
